import React from "react";

const STEPS = [
  ["Make Instagram a Professional account", "Instagram app → Settings → Account type and tools → Switch to professional account → Business (or Creator). No Facebook Page needed."],
  ["Open your Meta app's Instagram settings", "developers.facebook.com/apps → your app → Instagram → API setup with Instagram login. (Your Instagram App ID + Secret are already saved in the studio.)"],
  ["Add the redirect URL", "Section 3 'Set up Instagram business login' → Business login settings → OAuth redirect URIs → paste the URL shown below → Save. Add your live-site URL too once you deploy."],
  ["Add yourself as a tester", "App roles → Roles → Add people → Instagram Tester → your Instagram username. Then in Instagram: Settings → Website permissions → Apps and websites → Tester invites → Accept."],
  ["Press Connect with Instagram", "Log in, approve 'basic' and 'content publish'. You'll land back here, connected. Tokens refresh automatically before they expire."],
];

export const IgSetupGuide = () => (
  <details className="group rounded-xl border border-zinc-800 bg-black/30 p-3" data-testid="ig-setup-guide">
    <summary className="cursor-pointer text-xs font-black uppercase tracking-widest text-[#BEFF38]">How to connect (5 steps, ~5 min)</summary>
    <ol className="mt-3 grid gap-3">
      {STEPS.map(([t, d], i) => (
        <li key={t} className="flex gap-3">
          <span className="text-[#BEFF38] font-black text-lg leading-none w-6 shrink-0" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>{String(i + 1).padStart(2, "0")}</span>
          <span className="text-sm"><span className="text-white font-semibold block">{t}</span><span className="text-zinc-400 text-xs leading-relaxed">{d}</span></span>
        </li>
      ))}
    </ol>
  </details>
);
